import React from "react";
import { Switch, Route } from "react-router-dom";
import ConfirmPageContainer from "../containers/confirmPageContainer";

function RouterConfirmPage(){
    return(
        <Route path="/ConfirmPage">
            <Switch>
                <Route path="/ConfirmPage/PlanCF/:id/Step/:step/:email" exact>
                    <ConfirmPageContainer />
                </Route>
                <Route path="/ConfirmPage/PlanRJ/:id/Step/:step/:email" exact>
                    <ConfirmPageContainer />
                </Route>
            </Switch>
        </Route>
    )
}

export default RouterConfirmPage;